module.exports = __webpack_public_path__ + "static/media/VY.b1636a87.png";